import { EDIT_CUSTOMER_STATION_FAILT } from './types';

export function editStationFault(editPayload) {
  return {
    type: EDIT_CUSTOMER_STATION_FAILT,
    editPayload
  }
}

export function clearState() {
  return {
    type: 'CLEAR_STATE',
  }
}